import { Routes } from '@angular/router';
import { DashboardLayoutComponent } from './layout/components/dashboard-layout/dashboard-layout.component';
import { authGuard } from './auth/guards/auth.guard';
import { logoutGuard } from './auth/guards/logout.guard';
import { unsavedChangesGuard } from './shared/guards/unsaved-changes.guard';

export const routes: Routes = [
  // Authentication routes
  {
    path: 'signin',
    loadComponent: () => import('./auth/components/signin/signin.component').then((module) => module.SigninComponent),
    canActivate: [logoutGuard],
  },
  {
    path: 'forgotPassword',
    loadComponent: () => import('./auth/components/forgot-password/forgot-password.component').then((module) => module.ForgotPasswordComponent),
  },
  {
    path: 'resetPassword/:token',
    loadComponent: () => import('./auth/components/reset-password/reset-password.component').then((module) => module.ResetPasswordComponent),
  },

  // Protected application routes
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'analytics/signup',
        pathMatch: 'full'
      },
      {
        path: 'analytics',
        children: [
          {
            path: 'signup',
            loadComponent: () => import('./signup-analytics/components/signup-analytics.component').then((module) => module.SignupAnalyticsComponent),
          },
          {
            path: 'trial-conversion',
            loadComponent: () => import('./trial-conversions/components/trial-conversions.component').then((module) => module.TrialConversionsComponent),
          }
        ],
      },
      {
        path: 'logs',
        children: [
          {
            path: 'event-error-logs',
            loadComponent: () => import('./logs/components/event-error-log/event-error-log.component').then((module) => module.EventErrorLogComponent),
          },
          { path: '', redirectTo: 'event-error-logs', pathMatch: 'full' },
        ],
      },
      {
        path: 'users',
        children: [
          {
            path: 'roles',
            children: [
              {
                path: 'form',
                loadComponent: () => import('./user-management/components/role-form/role-form.component').then((module) => module.RoleFormComponent),
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'form/:id',
                loadComponent: () => import('./user-management/components/role-form/role-form.component').then((module) => module.RoleFormComponent),
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: '',
                loadComponent: () => import('./user-management/components/role-list/role-list.component').then((module) => module.RoleListComponent),
              },
            ],
          },
          {
            path: 'staff',
            children: [
              {
                path: 'form',
                loadComponent: () => import('./user-management/components/staff-form/staff-form.component').then((module) => module.StaffFormComponent),
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: 'form/:id',
                loadComponent: () => import('./user-management/components/staff-form/staff-form.component').then((module) => module.StaffFormComponent),
                canDeactivate: [unsavedChangesGuard],
              },
              {
                path: '',
                loadComponent: () => import('./user-management/components/staff-list/staff-list.component').then((module) => module.StaffListComponent),
              },
            ],
          },
          { path: '', redirectTo: 'roles', pathMatch: 'full' }
        ],
      }
    ]
  },

  // Unknown routes
  // { path: '**', redirectTo: 'analytics' },
];